"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Utils = require("../Utils");
var _templateObject;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
const Container = exports.Container = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: ", ";\n    ", "\n    ", "\n"])), (0, _Utils.getProp)('display'), (0, _Utils.parseProp)('margin'), _ref => {
  let {
    zIndex
  } = _ref;
  return zIndex !== undefined ? "z-index: ".concat(zIndex, ";") : '';
});